import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  title: {
    margin: 0,
    marginBottom: 15,
    fontSize: 16,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  sunIcon: {
    fontSize: '3.5rem',
    color: theme.custom.darkBlue,
  },
  text: {
    display: 'block',
    padding: 20,
    fontSize: 15,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  balanceBox: {
    marginTop: 10,
    padding: 10,
    background: '#F2F4F8',
    borderRadius: 2,
    textAlign: 'center',
  },
  red: {
    color: theme.custom.warning,
  },
  green: {
    color: theme.custom.accept,
  },
}));
